import React from 'react';
import { Container, SectionTitle } from '../../../components/ui';

export default function AboutSection() {
  return (
    <section id="tentang-kami" className="py-16 bg-green-to-white-soft">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <SectionTitle title="Tentang Kami" />
            <p className="mt-4 text-am-text-700 leading-relaxed">
              PT AMANAH MULIA NIAGA berdiri pada Desember 2023, berkantor di Plaza HNI, Jalan Raya Kalimalang – Billymoon, Pondok Kelapa, Duren Sawit, Jaktim.
            </p>
            <p className="mt-4 text-am-text-700 leading-relaxed">
            PT AMANAH MULIA NIAGA menyediakan kebutuhan sehari-hari untuk perseorangan, rumah tangga, katering, rumah makan dan institusi lainnya dengan jaminan barang pilihan, terjangkau, lengkap dan tentunya halal yang telah terlisensi oleh BPPOM MUI dan lembaga resmi pemerintah lainnya. Kami menamai gerai kami dengan Amanstore.
            </p>
          </div>

          <div className="flex justify-center lg:justify-end">
            <img src={require('../../../images/Banner-Aman-Mart-1.png')} alt="Aman Mart" className="w-full max-w-md rounded-lg shadow-lg" />
          </div>
        </div>
      </Container>
    </section>
  );
}
